var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('healthchecks-form',{attrs:{"healthcheck-id":_vm.healthcheckId,"distribution-id":_vm.distributionId,"details":""},on:{"submit":_vm.update,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }